<template>
    <div class="pc-news-item">
    <a :href="'/post/' + news.uid + '.html'" target="_blank" style="text-decoration:none">
        
        <div class="left-image">
           <img :src="news.photo"> 
        </div>
        <div class="right-content">
            <div class="main-title">
                <!-- 华兴资本包凡： 24年投资生涯和他背后的中国投资江湖华兴资本包凡： 24年投资生涯和他背后的中国投资江湖华兴资本包凡： 24年投 -->
                <!-- {{ news.title}} -->
                {{ news.title.length > 50 ? news.title.substring(0,48) + '...' : news.title }}


            </div>
            <div class="sub-title">
                <!-- 别光知道 《欢乐颂》的小包，现实中的『包总』和他背后的中国投资江湖更精彩！！！！！别光知道 《欢乐颂》的小包，现实中的『包总』和他背后的中国投资江湖更精彩！！！！！！ -->
                <!-- {{ news.intro }} -->
                {{ news.intro.length > 160 ? news.intro.substring(0,160) + '...' : news.intro }}

            </div>
            <div class="bottom-info">
                <div class="tag">
                   <!-- {{ news.article_type }} -->
                </div>
                <div class="auther-info">
                    <div class="name">
                        {{ news.author.name }} 
                    </div>
                    <div class="time">
                        <!-- {{ news.time }} -->
                        {{ timeAgo(news.time) }}
                    </div>
                </div>
            </div>
        </div>
    </a>
    </div>
</template>

<script>
import moment from 'moment'

moment.locale('en', {
    relativeTime : {
        future: "%s后",
        past: "%s前",
        s:  "几秒",
        m:  "1 分钟",
        mm: "%d 分钟",
        h:  "1 小时",
        hh: "%d 小时",
        d:  "1 天",
        dd: "%d 天",
        M:  "1 个月",
        MM: "%d 月",
        y:  "1 年",
        yy: "%d 年"
    }
});

export default{
    props:['news'],
    methods:{
        timeAgo(time){
           return  moment(time).fromNow() 
        }
    }
}
</script>

<style lang="scss">
.pc-news-item{
    width: 96%;
    margin: 0 auto;
    border-top: 1px solid #ededed;
    padding: 14px 0;
    .left-image{
        display: inline-block;
        img{
            width: 240px;
        }
    }
    .right-content{
        width: 800px;
        display: inline-block;
        vertical-align: top;
        padding-left: 20px;
        .main-title{
            height: 70px;
            font-size: 22px;
            color: #212121;
        }
        .sub-title{
            height: 60px;
            font-size: 14px;
            color: #878787;
        }
        .bottom-info{
            height: 30px;
            line-height: 30px;
            .tag{
                display: inline-block;
                color:#5a86da;
            }
            .auther-info{
                display: inline-block;
                color: #878787;
                .name{
                    display: inline-block;
                }
                .time{
                    display: inline-block;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// PcNewsItem.vue?a31dcb40